import React, { useEffect, useRef, useState } from "react";
import "./aboutpage.css"

const AboutPage = () => {

  const topRef = useRef();
  const midRef = useRef();

  const [isTopVisible, setIsTopVisible] = useState(false);
  const [isMidVisible, setIsMidVisible] = useState(false);

  useEffect(() => {
    const topObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsTopVisible(true);
          topObserver.unobserve(entry.target);
        }
      });
    });

    const midObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsMidVisible(true);
          midObserver.unobserve(entry.target);
        }
      });
    });

    if (topRef.current) {
      topObserver.observe(topRef.current);
    }

    if (midRef.current) {
      midObserver.observe(midRef.current);
    }

    return () => {
      if (topRef.current) {
        topObserver.unobserve(topRef.current);
      }

      if (midRef.current) {
        midObserver.unobserve(midRef.current);
      }
    };
  }, []);

  return (
    <div className='about-main-container'>

      <div className={`about-top-container relative ${isTopVisible ? "fade-in" : ""}`} ref={topRef}>
       
      </div>

      <div className={`about-bottom-container ${isMidVisible ? "fade-in" : ""}`} ref={midRef}>

      </div>

    </div>
  )
}

export default AboutPage